// NOTE: IMPORT OTHER CONSTANTS AND DEPENDENCIES
import Root from "../Layout/Root";
import { createBrowserRouter } from "react-router-dom";

// NOTE: IMPORT AUTH PAGES
// import SignIn from "../pages/Login/SignIn";
import SignIn from "../pages/Login/SignInLandLoad";
import SignUp from "../pages/Login/SignUp";
import ForgotPassword from "../pages/Login/ForgotPasswordLandLoad";
// import VerifyOTP from "../pages/Login/VerifyOTP";
import SetNewPassword from "../pages/Login/SetNewPasswordLandLoad";

// NOTE: IMPORT COMMON PAGES
import ErrorPage from "../error/Error";
import InternalServerError from "../error/ServerError";
import NotFoundPage from "../error/NotFoundError";
import TermsAndCondition from "../pages/TermsAndCondition";

// NOTE: IMPORT TEST PAGES
import { UseConfirmationTesting } from "../pages/TestConfirmation";
import LandLordTestArea from "../pages/Samples/LandLordTestArea";

// NOTE: IMPORT HOOKS
import {
  ProtectedLandLodRoute,
  ProtectedRedirect,
  ProtectedRoute,
} from "../components/protectedAndPublicRoute";
import PublicRoute from "../components/PublicRoute";
import LandLodClientHome from "../pages/Tenant/LandLodClientHome";
import LandlodLayout from "../Layout/LandlodLayout";

// IMPORT LANDLORD NAVIGATION PAGES
import UserProfile from "../pages/LandLord/UserProfileTest";
import OccupancyRatePage from "../pages/LandLord/OccupancyRate";
import PaymentDistributionPage from "../pages/LandLord/PaymentDistribution";
import PaymentHistoryPage from "../pages/LandLord/PaymentHistory";
import PortfolioPerformanceReportPage from "../pages/LandLord/PortfolioPerformanceReport";
import LegalSupportPage from "../pages/LandLord/LegalSupport";
import TaxConsulationPage from "../pages/LandLord/TaxConsulation";
import ReqMaintaincePage from "../pages/LandLord/ReqMaintaince";

import TenantRentPayment from "../pages/Tenant/TenantRentPayment";
import ViewPaymentsPage from "../pages/LandLord/ViewPaymentsPage";
import ManageProperty from "../pages/LandLord/ManageLands";
import LandLordTestSummary from "../pages/LandLord/LandLordTestSummary";
import NotificationCenter from "../pages/LandLord/NotificationCenter";
import Overview from "../pages/LandLord/Overview";
import Tenantdetailsform from "../pages/LandLord/tenantdetailsform";
import LoginLayout from "../Layout/LoginLayout";
import TenantDetailPage from "../pages/LandLord/TenatDetailPage";

import SamplePage from "../pages/Samples/SamplePage";
import PrivacyPolicy from "../pages/PrivacyPolicy";

const router = createBrowserRouter([
  {
    path: "/",
    element: <PublicRoute />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        element: <Root />,
        children: [
          {
            index: true,
            element: <LandLodClientHome />,
          },
          {
            path: "make-payment/:unitCode/:unitId",
            element: <TenantRentPayment />,
          },
          {
            path: "/terms-and-conditions",
            element: <TermsAndCondition />,
          },
          {
            path: "/privacy-policy",
            element: <PrivacyPolicy/>,
          },
        ],
      },
    ],
  },
  // LandLord Routes
  {
    path: "/landlords",
    element: <ProtectedLandLodRoute />,
    children: [
      {
        element: <LandlodLayout />,
        children: [
          {
            path: "",
            element: <PortfolioPerformanceReportPage />,
          },
          {
            path: "user-profile",
            element: <UserProfile />,
          },
          {
            path: "portfolio-performance",
            element: <PortfolioPerformanceReportPage />,
          },
          {
            path: "occupancy-rate",
            element: <OccupancyRatePage />,
          },
          {
            path: "payment-distribution",
            element: <PaymentDistributionPage />,
          },
          {
            path: "payment-history",
            element: <PaymentHistoryPage />,
          },
          {
            path: "manage-property",
            element: <ManageProperty />,
          },
          {
            path: "manage-property/view-details/:propertyId",
            element: <LandLordTestSummary />,
          },
          {
            path: "manage-property/payments/:unitId",
            element: <ViewPaymentsPage />,
          },
          {
            path: "manage-property/:propertyId/:unitId/add-tenant",
            element: <TenantDetailPage />,
          },
          {
            path: "manage-property/:propertyId/:unitId/edit-tenant",
            element: <TenantDetailPage />,
          },
          {
            path: "notifications",
            element: <NotificationCenter />,
          },
          {
            path: "legal-support",
            element: <LegalSupportPage />,
          },
          {
            path: "request-maintenance",
            element: <ReqMaintaincePage />,
          },
          {
            path: "tax-consulation",
            element: <TaxConsulationPage />,
          },
          {
            path: "sample",
            element: <SamplePage />,
          },
        ],
      },
    ],
  },

  // Auth Routes with LoginLayout
  {
    path: "/",
    element: <LoginLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "signin",
        element: <SignIn />,
      },
      {
        path: "forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "reset-password",
        element: <SetNewPassword />,
      },
      {
        path: "signup",
        element: <SignUp />,
      },
    ],
  },

  // Test Routes
  {
    path: "/test-confirmation",
    element: <UseConfirmationTesting />,
    errorElement: <ErrorPage />,
  },
  {
    path: "landLordTestArea",
    element: <LandLordTestArea />,
  },

  // Error Page
  {
    path: "/server-error",
    element: <InternalServerError />,
    errorElement: <ErrorPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/error",
    element: <ErrorPage />,
    errorElement: <ErrorPage />,
  },
]);

export default router;
